export class AccountingSettingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async editSetting({ body, companyId }) {
    return this.#http.put(`/accountingSetting/${companyId}`, body);
  }

  async getSettings() {
    return this.#http.get('/accountingSetting');
  }
}
